<template>
<div class="col-12 text-left">
    <h3 class="p-2">
        <small class="text-muted">Member</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-9">
            <label for="email-input">Email</label>
            <input type="text" class="form-control" v-model="members.email" id="email-input" aria-describedby="email" placeholder="Email">
        </div>
        <div class="form-group col-3">
            <label for="active-input">Active</label>
            <input type="checkbox" class="form-control" v-model="members.status" id="acitve-input" />
        </div>
    </div>
    <div class="row">
        <div class="form-group col-9">
            <label for="name-input">Full Name</label>
            <input type="text" class="form-control" v-model="members.fullName" id="name-input" aria-describedby="name" placeholder="Nama Lengkap">
        </div>
        <div class="form-group col-3">
            <label for="active-input">Role Admin</label>
            <input type="checkbox" class="form-control" v-model="members.role" id="acitve-input" />
        </div>
    </div>
    <div class="row">
        <div class="form-group col-9">
            <label for="name-input">Phone Number</label>
            <input type="text" class="form-control" v-model="members.phoneNumber" id="name-input" aria-describedby="name" placeholder="Nomor Telepon">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-9">
            <label for="type-input">Password</label>
            <input type="password" class="form-control" v-model="members.password" id="password-input" aria-describedby="password" placeholder="Password">
        </div>
    </div>
    <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="members.memberVehicle"></app-datatable>
    <br />
    <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
    <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
</div>
</template>

<script>
import api from '../../../services/api'
import { Member } from '../../../models/member'
import { MemberVehicle } from '../../../models/memberVehicle'
import AppLookupField from '../../../components/AppLookupField.vue'
import AppDatatable from '../../../components/AppDatatable.vue'
import AppDatePicker from '../../../components/AppDatePicker.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker
    },
    data() {
        return {
            members: {
                ...Member,
                memberVehicle: []
            },
            newDetail: MemberVehicle ,
            dtElements: [
                {
                    title: 'Police Number',
                    column: 'policeNumber',
                    type: 'text',
                    width: 3,
                },
                {
                    title: 'Merek',
                    column: 'brand',
                    type: 'lookup',
                    width: 6,
                    lookup: {
                        id: 'vehicleBrand',
                        title: 'Data Merek Kendaraan',
                        type: 'table',
                        apiUrl: 'vehicle-brand',
                        filter: ['name'],
                        fields: [
                            {
                                placeholder: 'Merek',
                                width: 5,
                                column: 'brand'
                            }
                        ],
                        dtElements: [
                            {
                                title: 'Nama',
                                column: 'name'
                            }
                        ],
                        affectedField: [
                            {
                                from: 'id',
                                to: 'brandId'
                            },
                            {
                                from: 'name',
                                to: 'brand'
                            }
                        ]
                    }
                },
                {
                    title: 'Name',
                    column: 'name',
                    type: 'text',
                    width: 3,
                },
                {
                    title: 'Type',
                    column: 'type',
                    type: 'text',
                    width: 3,
                },
                {
                    title: 'Year',
                    column: 'year',
                    type: 'number',
                    width: 3,
                }
            ]
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const memberApi = api('member')
            this.members = await memberApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const memberApi = api('member')
            if(this.$route.query.id !== undefined) {
                await memberApi.update(this.members, this.$route.query.id)
            } else {
                await memberApi.create(this.members)
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        }
    }
}
</script>